var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{staticClass:"output overview",attrs:{"id":"overview-panel","width":"320","height":"480"}})
}
var staticRenderFns = []

export { render, staticRenderFns }